import React from 'react';
import { Typography } from '@mui/material';
import TypedValue from './../TypedValue';

const FluidValue = ({ typographyVariant, colour, value, valueType, accuracy, noData, defaultRemFontSize = 1.5, maxRemFontSize = 2.75, valueLengthDivisor = 4, textAlign = 'inherit' }) => {
    const typedValue = TypedValue({ value, type: valueType, accuracy, noData });

    const valueStringLength = typedValue?.toString().length ?? 1;

    const maxClamp = maxRemFontSize - (valueStringLength / valueLengthDivisor);

    return (
        <Typography
            variant={typographyVariant}
            sx={{
                color: colour,
                fontSize: `clamp(${defaultRemFontSize}rem, -${maxClamp}rem + 5vw, ${maxClamp}rem)`,
                textAlign
            }}
        >
            {typedValue}
        </Typography>
    );
};

export default FluidValue;